/**
 * Genera un número aleatorio entre 0 y 1000
 * @returns {number} Número aleatorio
 */
export function randId() {
  return secureRandomInt(1001);
}

/**
 * Genera un entero aleatorio seguro entre 0 (incluido) y maxExclusive (excluido).
 */
export function secureRandomInt(maxExclusive: number): number {
  if (!Number.isFinite(maxExclusive) || maxExclusive <= 0) {
    throw new Error('maxExclusive debe ser un número mayor a 0');
  }

  if (typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.getRandomValues === 'function') {
    const array = new Uint32Array(1);
    globalThis.crypto.getRandomValues(array);
    return array[0] % Math.floor(maxExclusive);
  }

  // Fallback sin PRNG inseguro para entornos sin Web Crypto.
  const now = Date.now();
  return now % Math.floor(maxExclusive);
}
